module.exports = __webpack_public_path__ + "TB_Warning_Melody_A.wav.80750997.mp3";


//////////////////
// WEBPACK FOOTER
// ./client/components/sounds/warning/TB_Warning_Melody_A.wav.mp3
// module id = 510
// module chunks = 0